export var StockStatuses;
(function (StockStatuses) {
    StockStatuses["InStock"] = "IN_STOCK";
    StockStatuses["OutOfStock"] = "OUT_OF_STOCK";
    StockStatuses["LowStock"] = "LOW_STOCK";
})(StockStatuses || (StockStatuses = {}));
